import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDevicesRequest } from "../../../store/brotherPlus/getDevices/getDevicesSlice";
import { getLocalSessionData, getUserSessionData } from "../../../utils/Authentication/handleUserSession";
import { DASHBOARD_REFRESH_INTERVAL, LOCALSESSIONDATAKEYS } from "../../../constants/AppConstants";
import useIntervalAsync from "../../../utils/CustomHooks/useIntervalAsync";
import useBrotherPlusUpdateDeviceStatus from "../../../utils/CustomHooks/useBrotherPlusUpdateDeviceStatus";
import { getPrintHistoryRequest, getPrintHistoryReset } from "../../../store/brotherPlus/getPrintHistory/getPrintHistorySlice";
import { SOURCE_MY_DEVICE } from "../../MyDevices/components/SuppliesComponent";
import HybridLayout from "./Layout/HybridLayout";
import MyDevicesBPlusOnlyWidgets from "./Layout/MyDevicesBPlusOnlyWidgets";
import "./Dashboard.css";

export const DISPLAY_CONTENT_TYPE = { 'pagesUsedCount': 'PAGES_USED_COUNT', "duplexPagesCount": "DUPLEX_PAGES_COUNT" };

const BrotherPlusDashboard = (props) => {
  const {
    source = null,
    selectedDeviceID = null,
    isBothEnrolledServices = false,
    deviceData,
    handleDeviceStatusDetails,
    showEcoWidget
  } = props
  const dispatch = useDispatch()
  const getDevicesResponse = useSelector((state => state.BROTHERPLUS.getDevices))
  const getPrintHistoryResponse = useSelector((state) => state.BROTHERPLUS.getPrintHistory)
  const userId = getUserSessionData('UserId');
  const deviceId = (source === SOURCE_MY_DEVICE && selectedDeviceID)
    ? selectedDeviceID
    : getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)

  const [deviceStatus, setDeviceStatus] = useState({
    success: false,
    loader: false,
    response: null,
    error: false
  });

  // below code snippet is to clear the previous state of
  // GetDeviceStatus API when a new device is selected in MyDevices page
  useEffect(() => {
  if (source === SOURCE_MY_DEVICE && deviceStatus.success && selectedDeviceID !== null &&
    (deviceStatus?.response?.deviceId !== selectedDeviceID)) {
    setDeviceStatus({
      success: false,
      loader: true,
      response: null,
      error: false
    });
  }
}, [source,selectedDeviceID,deviceStatus.success,deviceStatus?.response?.deviceId]);

  // below code snippet is to clear the previous state of
  // GetPrintHistory API when a new device is selected in MyDevices page
  useEffect(() => {
    if (source === SOURCE_MY_DEVICE && getPrintHistoryResponse.success && selectedDeviceID !== null &&
      (getPrintHistoryResponse?.printHistory?.deviceId !== selectedDeviceID)) {
      dispatch(getPrintHistoryReset());
    }
  }, [source,selectedDeviceID,getPrintHistoryResponse.success,getPrintHistoryResponse?.printHistory?.deviceId,dispatch]);


  useEffect(() => {
    setDeviceStatus(prev => ({ ...prev, loader: true }));
    dispatch(getDevicesRequest({ userId }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect( () =>{
      dispatch(getPrintHistoryRequest({ userId, deviceId }));
      // eslint-disable-next-line
  },[deviceId] )

  const updateState = useBrotherPlusUpdateDeviceStatus({ deviceId, userId, setDeviceStatus });
  useIntervalAsync(updateState, DASHBOARD_REFRESH_INTERVAL);

  useEffect(() => {
    // set devicestatus data to send to parent callback functions
    if (handleDeviceStatusDetails) {
        // Only send to parent if they match
        if (deviceId === selectedDeviceID) {
            handleDeviceStatusDetails(deviceStatus);
        }
    }
  }, [deviceStatus, handleDeviceStatusDetails, deviceId, selectedDeviceID]);

  const BPlusTileInfo = {
    'source': source,
    'deviceStatus': deviceStatus,
    'printHistoryInfo': getPrintHistoryResponse,
    'deviceResponse': getDevicesResponse,
    "deviceWarrantyStatus": deviceStatus?.response?.genuineInfo
  }

  return (
    (isBothEnrolledServices)
      ? <HybridLayout BPlusTileInfo={BPlusTileInfo} source={source} />
      : (source === SOURCE_MY_DEVICE)
        ? <MyDevicesBPlusOnlyWidgets BPlusTileInfo={BPlusTileInfo} deviceData={deviceData} showEcoWidget={showEcoWidget}/>
        : <></>
  )
}

export default BrotherPlusDashboard;